function initReviewsMarquee() {
    const banner = document.querySelector(".home-page-reviews-banner-section");
    const sliderContainer = document.querySelector(
        ".home-page-reviews-banner-section__slider-container",
    );
    const items = document.querySelector(
        ".home-page-reviews-banner-section__customer-review-items",
    );
    if (!banner || !sliderContainer || !items) return;

    const SPEED = 40; // px per second

    const wrapper = document.createElement("div");
    wrapper.style.cssText = "display: flex; will-change: transform;";

    const clone = items.cloneNode(true);
    const gap = parseFloat(getComputedStyle(items).gap) || 32;
    wrapper.style.gap = gap + "px";

    sliderContainer.appendChild(wrapper);
    wrapper.appendChild(items);
    wrapper.appendChild(clone);

    const scrollDistance = items.offsetWidth + gap;

    let offset = 0;
    let lastTime = null;
    let paused = false;

    function tick(timestamp) {
        if (!paused && lastTime !== null) {
            const delta = Math.min(timestamp - lastTime, 100);
            offset = (offset + (SPEED * delta) / 1000) % scrollDistance;
            wrapper.style.transform = `translateX(-${offset}px)`;
        }
        lastTime = paused ? null : timestamp;
        requestAnimationFrame(tick);
    }

    banner.addEventListener("mouseenter", () => {
        paused = true;
    });
    banner.addEventListener("mouseleave", () => {
        paused = false;
    });
    banner.addEventListener(
        "touchstart",
        () => {
            paused = true;
        },
        { passive: true },
    );
    banner.addEventListener("touchend", () => {
        paused = false;
    });
    banner.addEventListener("touchcancel", () => {
        paused = false;
    });

    requestAnimationFrame(tick);
}

document.addEventListener("DOMContentLoaded", initReviewsMarquee);
